import 'bootstrap/js/dist/modal'
import i18n from 'i18n'
import Session from 'javascripts/layouts/v2/Session'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import { session_path } from 'routes'
import { appTheme } from 'spa/config/styled'
import { ThemeProvider } from 'styled-components'
import { SessionContext } from '../profile_sheets/information_disclosures/application'

import JobOfferContentView from './JobOfferContentView'
import JobOfferSideNav from './JobOfferSideNav'
import './show'

window.addEventListener('DOMContentLoaded', () => {

  if (!document.querySelector('body.controller--job_offers')) return false

  const sideNav = document.querySelector('[data-react-job-offer-side-nav]')
  if (sideNav) {
    ReactDOM.render(<JobOfferSideNav />, sideNav)
  }

  const contentView = document.querySelector('[data-react-job-offer-content-view]')
  if (contentView) {
    const props = JSON.parse(contentView.dataset.reactJobOfferContentView)
    ReactDOM.render(<JobOfferContentViewForSlim {...props} />, contentView)
  }
})

const JobOfferContentViewForSlim: React.FC = (props) => {
  const [session, setSession] = React.useState<Session>(null)
  useEffect(() => {
    void fetch(session_path())
      .then(response => response.json())
      .then((json: Session) => setSession(json))
  }, [])
  return (
    <I18nextProvider i18n={ i18n }>
      <SessionContext.Provider value={session}>
        <BrowserRouter>
          <ThemeProvider theme={appTheme}>
            <JobOfferContentView {...props} />
          </ThemeProvider>
        </BrowserRouter>
      </SessionContext.Provider>
    </I18nextProvider>
  )
}
